import SocialMedia from "components/About/SocialMedia";
import HeroBusinessConsulting from "components/BusinessConsulting/HeroBusinessConsulting";
import ListBusinessConsulting from "components/BusinessConsulting/ListBusinessConsulting";
import MissionBusinessConsulting from "components/BusinessConsulting/MissionBusinessConsulting";
import QuoteBusinessConsulting from "components/BusinessConsulting/QuoteBusinessConsulting";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import PriceSection from "components/Service/PriceSection";
import React from "react";

const BusinessConsulting = () => {
  return (
    <div>
      <HeroBusinessConsulting />
      <QuoteBusinessConsulting />
      <MissionBusinessConsulting />
      <ListBusinessConsulting />
      <PriceSection />
    </div>
  );
};

export default BusinessConsulting;
